import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-black h-screen font-mono pt-10" }
const _hoisted_2 = {
  key: 0,
  class: "w-2/3 print:w-full h-5/6 mx-auto border-2 border-gray-800 print:border-0"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "print:fixed print:left-5 print:bottom-0 print:w-full" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "uppercase bg-red-600 text-white text-center py-1 print:text-black print:text-2xl" }, " +++ For your eyes only +++ "),
  /*#__PURE__*/_createElementVNode("h1", { class: "uppercase bg-red-600 text-white text-center py-1 hidden print:block print:text-black print:text-2xl" }, " Burn immediately after use ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "uppercase text-center py-1 hidden print:block print:text-black print:text-4xl" }, " MISSION: ... and make it complete ", -1)
const _hoisted_5 = { class: "uppercase text-center py-1 hidden print:block print:text-black print:text-2xl" }
const _hoisted_6 = { class: "w-full h-8 overflow-hidden border-b-2 border-gray-800 flex text-sm print:hidden" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "inline-block align-text-top" }, "👤", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Kontaktdaten ")
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "inline-block align-text-top" }, "❎", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Ausloggen ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "w-full h-5/6 flex print:h-auto" }
const _hoisted_15 = { class: "flex-grow px-2 py-1 overflow-x-hidden overflow-y-scroll" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "grid grid-cols-2 gap-4 w-96 mt-2 print:hidden"
}
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "inline-block align-text-top" }, "✅", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Mission annehmen ")
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = ["disabled", "onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "inline-block align-text-top" }, "❌", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Mission ablehnen ")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "h-64 w-64 flex-shrink-0"
}
const _hoisted_30 = { class: "w-full flex print:hidden mt-5" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "inline-block align-text-top mr-1" }, "🖨", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Mission drucken ")
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "inline-block align-text-top mr-1" }, "📨", -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Mission abschicken ")
const _hoisted_36 = [
  _hoisted_34,
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_geo_json = _resolveComponent("l-geo-json")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("h2", _hoisted_5, " Persönlich für " + _toDisplayString(_ctx.providedPerson.firstName) + " " + _toDisplayString(_ctx.providedPerson.lastName), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "text-center w-32 h-full bg-blue-900 hover:bg-blue-800 text-white",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showContactData()))
            }, _hoisted_9),
            _hoisted_10,
            _createElementVNode("button", {
              class: "text-center w-32 h-full bg-blue-900 hover:bg-blue-800 text-white self-end",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
            }, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages.filter((m) => m.visible), (m) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: m.id,
                  class: "bg-black px-5 py-3 hover:bg-gray-900 mb-px print:mt-10",
                  style: {"page-break-inside":"avoid"}
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex flow-col p-5 gap-5", 
                m.accepted
                  ? 'bg-green-900 bg-opacity-50 text-white print:text-black'
                  : m.rejected
                  ? 'text-grey-300 bg-red-900 bg-opacity-20 print:hidden'
                  : m.id == 1 ? 'text-white print:text-black' : 'text-white print:text-grey-500'
              ])
                  }, [
                    _createElementVNode("div", _hoisted_16, [
                      (m.date)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(m.date), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("h2", {
                        class: _normalizeClass(["font-bold mb-2 text-lg", m.id == 1 ? 'print:hidden' : ''])
                      }, _toDisplayString(m.title), 3),
                      _createElementVNode("p", {
                        innerHTML: m.text.replace(/(?:\r\n|\r|\n)/g, '<br/>')
                      }, null, 8, _hoisted_18),
                      (m.address)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, "Adresse: " + _toDisplayString(m.address), 1))
                        : _createCommentVNode("", true),
                      (m.invited)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["text-center h-full self-end", 
                      m.accepted
                        ? 'bg-grey-900 hover:bg-grey-900'
                        : 'bg-green-900 hover:bg-green-800 text-white'
                    ]),
                              disabled: m.accepted,
                              onClick: ($event: any) => (_ctx.acceptMission(m.id))
                            }, _hoisted_24, 10, _hoisted_21),
                            _createElementVNode("button", {
                              class: _normalizeClass(["text-center h-full self-end", 
                      m.rejected
                        ? 'bg-grey-900 hover:bg-grey-900'
                        : 'bg-red-900 hover:bg-red-800 text-white'
                    ]),
                              disabled: m.rejected,
                              onClick: ($event: any) => (_ctx.rejectMission(m.id))
                            }, _hoisted_28, 10, _hoisted_25)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (m.lat && m.long)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createVNode(_component_l_map, {
                            center: 
                    _ctx.toGeoJson(m).features[0].geometry.coordinates.reverse()
                  ,
                            minZoom: 17,
                            maxZoom: 17,
                            options: { zoomControl: false }
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_l_geo_json, {
                                geojson: _ctx.toGeoJson(m)
                              }, null, 8, ["geojson"]),
                              _createVNode(_component_l_tile_layer, {
                                class: "z-0",
                                url: "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?api_key=214a06d2-3e81-41e1-8382-6fbbd1689bfc"
                              })
                            ]),
                            _: 2
                          }, 1032, ["center"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("button", {
                  class: "text-center w-72 h-16 self-end bg-blue-900 hover:bg-blue-800 text-white object-center block mx-auto text-2xl",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.print()))
                }, _hoisted_33),
                _createElementVNode("button", {
                  class: "text-center w-72 h-16 self-end bg-blue-900 hover:bg-blue-800 text-white object-center block mx-auto text-2xl",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.outro()))
                }, _hoisted_36)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}